import axios from "axios";
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getContactUserListRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.CONTACT_USER_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CUP_CONTACT_USER_LIST_API,
    params: params,
  });
};

export const postContactUserPushRepo = (data) => {
  return axios({
    baseURL:
      ServiceUrls.CONTACT_USER_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_CUP_CONTACT_USER_PUSH_API,
    data: data,
    // headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postSendToNetcoreRepo = (data, params) => {
  return axios({
    baseURL:
      ServiceUrls.CONTACT_USER_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_CUP_SEND_TO_NETCORE_API + params.id,
    data: data,
  });
};

export const getSendToNetcoreRepo = (params) => {
  return axios({
    baseURL:
      ServiceUrls.CONTACT_USER_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CUP_SEND_TO_NETCORE_API + params.id,
    params: params,
  });
};

